import Image from 'next/image'
import { useDonation } from '../context/DonationContext'
import { useEffect, useState } from 'react'

export default function Header() {
  const { state: { masterDonations, filteredDonations } } = useDonation()
  const [hasData, setHasData] = useState(false)

  useEffect(() => {
    setHasData(masterDonations.length > 0)
  }, [masterDonations.length, filteredDonations.length])

  return (
    <div className="flex flex-col items-center mb-6">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          <Image 
            src="/assets/logo.png" 
            alt="INTLGEM Logo" 
            width={52} 
            height={52}
            className="w-auto max-h-[52px]"
          />
          <h1 className="text-2xl font-bold text-secondary ml-4">IntlGEM Donation Management</h1>
        </div>
        <div className="flex items-center gap-4">
          <div>
            <span className={`w-3 h-3 rounded-full inline-block ${hasData ? 'bg-green-500' : 'bg-red-500'}`} />
            <span className="text-sm ml-2">{hasData ? 'Data Loaded' : 'No Data'}</span>
          </div>
        </div>
      </div>
      {!hasData && (
        <p className="text-gray-600 mt-4">Upload a CSV file to get started</p>
      )}
    </div>
  )
}

